<template>
  <div class="home">
    <modal-tutorial ref="modalTutorial" @onBoardingNext="onBoardingNext"/>
    <b-modal id="modal-feedback-loading" hide-footer hide-header centered :no-enforce-focus="true">
      <b-row>
        <b-col sm="12">
          <b-col class="text-center engrenagem" sm="12">
            <img src="https://jaleko-files.s3.sa-east-1.amazonaws.com/img/gif.gif" alt="Carregando">
            <p>Aguarde! Estamos carregando o seu cronograma :)</p>
          </b-col>
        </b-col>
      </b-row>
    </b-modal>

    <b-container fluid="sm">
      <b-row>
        <b-col sm="9" class="mainCalendar">
          <div class="header d-flex flex-column flex-sm-row justify-content-between align-items-center">
            <h2 class="header-title">
              <v-icon class="header-icon">mdi-calendar-month</v-icon>
              Agenda de Estudos
            </h2>

            <v-btn id="criar-cronograma" rounded class="btn primary-button" color="#F47D3A" @click="$router.push({ name: 'criar'})">
              <v-icon>mdi-plus</v-icon>
              Criar novo cronograma
            </v-btn>

            <b-tooltip disabled ref="tooltip2" target="criar-cronograma" placement="bottomright" custom-class="tooltip-tutorial">
              <button type="button" class="close" aria-label="Close" @click="$refs.tooltip2.$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
              <p class="titulo">Crie seu cronograma</p>
              <p class="conteudo">Quer uma ajuda extra para se organizar nos estudos? Os cronogramas são ótimos aliados.</p>
              <div class="footer">
                <p>2 de 5</p>
                <div class="d-flex align-items-center">
                  <p class="voltar" @click="onBoardingReturn(1)">Voltar</p>
                  <v-btn rounded class="btn primary-button" color="#FFFFFF" @click="onBoardingNext(3)">
                    Próxima dica
                  </v-btn>
                </div>
              </div>
            </b-tooltip>
          </div>

          <calendar ref="calendar" @onBoardingNext="onBoardingNext" @onBoardingReturn="onBoardingReturn"></calendar>
        </b-col>

        <b-col lg="3" class="d-flex flex-column">
          <div class="header">
            <h2 class="header-title">
              <v-icon class="header-icon">mdi-timeline-clock</v-icon>
              Cronogramas
            </h2>

            <p class="header-subtitle">Gerencie os cronogramas já criados:</p>
          </div>

          <div class="schedules" id="gerenciar-cronograma">
            <div v-for="schedule in agenda" class="schedule-list-item" :key="schedule.id">
              <span>
                <v-icon class="schedule-icon">mdi-calendar-clock</v-icon>
                {{ schedulePeriod(schedule.data_inicio, schedule.data_fim) }}
              </span>

              <v-menu offset-y :nudge-width="100" :nudge-left="110">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" class="schedule-menu-card">mdi-dots-vertical</v-icon>
                </template>

                <v-list>
                  <v-list-item class="schedule-menu-list-item" @click="changeMonthView(schedule.data_inicio)">
                    <v-list-item-title>Abrir</v-list-item-title>
                  </v-list-item>

                  <v-list-item class="schedule-menu-list-item" @click="editSchedule(schedule.id)">
                    <v-list-item-title>Editar</v-list-item-title>
                  </v-list-item>

                  <v-list-item class="schedule-menu-list-item" @click="deleteSchedule(schedule.id)">
                    <v-list-item-title>Excluir</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>

            <div v-if="agenda.length === 0" class="no-schedules">
              <span class="no-schedule-message">Você ainda não criou um cronograma</span>

              <img
                  src="https://jaleko-files.s3-sa-east-1.amazonaws.com/topicos-imagem/6227df0c11efe_calendario_e_planta.svg"
                  alt="">

              <v-btn rounded dark class="btn dark-button" @click="$router.push({ name: 'criar'})">
                <v-icon class="theme--dark">mdi-plus</v-icon>
                Criar novo cronograma
              </v-btn>
            </div>

            <b-tooltip disabled ref="tooltip3" target="gerenciar-cronograma" placement="left" custom-class="tooltip-tutorial">
              <button type="button" class="close" aria-label="Close" @click="$refs.tooltip3.$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
              <p class="titulo">Gerenciador de cronogramas</p>
              <p class="conteudo">Aqui você vai encontrar todos os seus cronogramas criados. Você pode abrir, editar ou excluir cada um deles.</p>
              <div class="footer">
                <p>3 de 5</p>
                <div class="d-flex align-items-center">
                  <p class="voltar" @click="onBoardingReturn(2)">Voltar</p>
                  <v-btn rounded class="btn primary-button" color="#FFFFFF" @click="onBoardingNext(4)">
                    Próxima dica
                  </v-btn>
                </div>
              </div>
            </b-tooltip>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

import './style.scss'
import LoginUtils from '@/core/utils/login-utils'
import Calendar from '@/components/calendar/'
import ModalTutorial from '@/components/modals/tutorial'
import DateUtils from "@/core/utils/date-utils";
import Swal from "sweetalert2";

export default {
  name: 'Home',
  components: {
    Calendar,
    ModalTutorial
  },
  data() {
    return {
      tooltip4: 'tooltip4'
    }
  },
  watch: {
    loading(status) {
      if (status)
        this.$bvModal.show('modal-feedback-loading')
      else
        this.$bvModal.hide('modal-feedback-loading')
    }
  },
  mounted() {
    this.getAgenda(this.dateRange)
    if (!localStorage.getItem('tutorialAgenda')) {
      this.$refs.modalTutorial.show()
    }
  },
  computed: {
    ...mapGetters(['agenda', 'loading', 'dateRange']),
    isPwa() {
      return LoginUtils.isPwa();
    },
  },
  methods: {
    ...mapActions([
      'deleteCronograma',
      'getAgenda',
      'setCreationStep',
      'setCurrentDay',
      'setIsUpdate',
      'setScheduleId'
    ]),

    changeMonthView(start) {
      this.setCurrentDay(start)
    },

    async deleteSchedule(id) {
      const result = await Swal.fire({
        title: 'Excluir cronograma?',
        text: '',
        footer: '',
        showCancelButton: true,
        showCloseButton: true,
        confirmButtonColor: '#F47D3A',
        cancelButtonColor: '#FFF',
        confirmButtonText: 'Excluir cronograma',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
      })

      if (result.isConfirmed) {
        const response = await this.deleteCronograma(id)

        if (response) {
          await Swal.fire(
              'Deletado!',
              'Cronograma deletado com sucesso'
          )
        } else {
          await Swal.fire(
              'Deletado!',
              'Ocorreu um erro',
              'error'
          )
        }
      }
    },

    editSchedule(id) {
      this.setScheduleId(id)
      this.setCreationStep(1)
      this.setIsUpdate(true)
      this.$router.push({name: 'criar'})
    },

    schedulePeriod(start, finish) {
      const startDate = DateUtils.formatDate(start, 'DD') + '/' + DateUtils.formatDate(start, 'MM')
      const finishDate = DateUtils.formatDate(finish, 'DD') + '/' + DateUtils.formatDate(finish, 'MM')

      return startDate + ' a ' + finishDate
    },

    onBoardingReturn: function (step) {
      if (step === 1) {
        this.$bvModal.show('modal-tutorial')
        this.$refs.tooltip2.$emit('close')
      } else if (step === 2) {
        this.$refs.tooltip3.$emit('close')
        this.$refs.tooltip2.$emit('open')
      } else if (step === 3) {
        this.$refs.calendar.$refs.tooltip4.$emit('close')
        this.$refs.tooltip3.$emit('open')
      }
    },

    onBoardingNext: function (step) {
      if (step === 2) {
        this.$bvModal.hide('modal-tutorial')
        this.$refs.tooltip2.$emit('open')
      } else if (step === 3) {
        this.$refs.tooltip2.$emit('close')
        this.$refs.tooltip3.$emit('open')
      } else if (step === 4) {
        this.$refs.tooltip3.$emit('close')
        this.$refs.calendar.$refs.tooltip4.$emit('open')
      } else if (step === 5) {
        this.$refs.calendar.$refs.tooltip4.$emit('close')
        this.$refs.calendar.$refs.tooltip5.$emit('open')
      } else if (step === 6) {
        this.$refs.calendar.$refs.tooltip5.$emit('close')
      }
    }
  }
}
</script>
